import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// set loading
const setDashboardLoading = (data) => (dispatch) => {
  dispatch({
    type: types.DashboardTypes.DASHBOARD_SET_LOADING,
    payload: data
  });
};

// clear result
const clearDashboardResult = () => (dispatch) => {
  dispatch({
    type: types.DashboardTypes.DASHBOARD_CLEAR_RESULT
  });
};

// clear error
const clearDashboardErrors = () => (dispatch) => {
  dispatch({
    type: types.DashboardTypes.DASHBOARD_CLEAR_ERRORS
  });
};

// unmount result
const unmountDashboardData = () => (dispatch) => {
  dispatch({
    type: types.DashboardTypes.DASHBOARD_UNMOUNT
  });
};

const getFunction = async (url, type, errorType, dispatch) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: data
    });
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    console.log(getRequestError.response.data);
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

// get dashboard data
const getDashboardData = (loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Dashboard_Api.GET_DAILY_ATT_DASHBOARD_API}`;
  const type = types.DashboardTypes.GET_DAILY_ATT_DASHBOARD;
  const errorType = types.DashboardTypes.DASHBOARD_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

const googleMapData = (todaysDate, loginType) => async (dispatch) => {
  const { baseUrlPython } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlPython}${api.Dashboard_Api.GET_DAILY_GOOGLE_MAP_API}`;
  const type = types.DashboardTypes.GET_DAILY_GOOGLE_MAP;
  const errorType = types.DashboardTypes.DASHBOARD_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

export {
  setDashboardLoading,
  clearDashboardErrors,
  clearDashboardResult,
  getDashboardData,
  unmountDashboardData,
  googleMapData
};
